import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-sham-logo-Full',
  standalone: true,
  templateUrl: '../../assets/sham-logo/Full.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamShamLogoFullIcon {}
